'use client';
import LoginModal from '@/components/Modals/ModalsContainer/LoginModal';
import React, { useState } from 'react';
import SignTemplate from './SignTemplate';
import { TRIGGERS } from '@/api/global';
import headStyle from '../../subuser/SubuserContent/styles.module.css';
import StepProgress from '@/components/Modals/ModalsContainer/LoginModal/StepProcess';
import BackButton from '../../subuser/SubuserContent/Stepper/BackButton';
import MainIcons from '@/icons/main';

export default function LoginContent() {
  const [activeLogin, setActiveLogin] = useState(1);
  const steps = [
    { id: 1, title: 'ورود به کارا' },
    { id: 2, title: 'کد تایید را وارد کنید' },
  ];
  const backFunction = () => {
    if (activeLogin > 0 && activeLogin <= steps?.length) {
      setActiveLogin(activeLogin - 1);
    }
  };
  const activeStep = steps?.filter((x) => x.id == activeLogin)?.[0];
  return (
    <SignTemplate>
      {activeLogin > 1 && activeLogin < 3 && (
        <BackButton
          text="بازگشت"
          onClick={() => {
            backFunction();
          }}
        />
      )}
      {activeLogin <= 2 && <StepProgress totalSteps={2} step={activeLogin} />}
      <h2 className={headStyle.title}> {activeStep?.title} </h2>
      <LoginModal modalKey={TRIGGERS.LOGIN_MODAL} active={activeLogin} setActive={setActiveLogin} />
      <div className={`${headStyle.footerlogin}`}>
        <MainIcons.LockIcon width="14px" height="14px" fill="var(--brand-light)" />
        <span>ورود امن با رمز یک‌بارمصرف پیامکی</span>
      </div>
    </SignTemplate>
  );
}
